import PropTypes from 'prop-types';

const basicTallyStyles = 'rounded-4xl py-0.5 px-2 font-semibold text-sm';

const typeStyles = {
  default: 'text-white bg-gray-5',
  danger: 'text-white bg-red-3',
  info: 'text-white bg-blue-3',
  success: 'text-white bg-green-3',
  warning: 'text-orange-5 bg-orange-3',
};
const Tally = ({ children, type }) => (
  <span className={`${basicTallyStyles} ${typeStyles[type]}`}>{children}</span>
);

Tally.propTypes = {
  /**
   * The content within the tally. Usually a number.
   */
  children: PropTypes.node.isRequired,
  /**
   * Tally type. Choose one of the following:
   */
  type: PropTypes.oneOf(Object.keys(typeStyles)),
};

Tally.defaultProps = {
  type: 'default',
};

export default Tally;
